import React from 'react';
import classNames from 'classnames';

enum EBookingStatusType {
  POTENTIAL = 'potential',
  REQUESTED = 'requested',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
}

export enum EUserStatusType {
  PENDING = 'pending',
  REJECTED = 'rejected',
  ACCEPTED = 'accepted',
  VERIFIED = 'verified',
}

interface IStatusProps extends React.HTMLAttributes<HTMLSpanElement> {
  type?: EBookingStatusType | EUserStatusType;
  children: React.ReactNode;
}

export const Status: React.FC<IStatusProps> = ({ className, type, children, ...rest }) => {
  const spanClassName = classNames(className, 
    'status before:rounded-full capitalize text-[14px] before:content-[""] before:w-[10px] before:h-[10px] before:mr-[10px] before:ml-[5px] inline-flex items-center',
    {
      'before:bg-red-92': type === EBookingStatusType.CANCELLED || type === EUserStatusType.REJECTED,
      'before:bg-yellow-15': type === EBookingStatusType.REQUESTED || type === EUserStatusType.ACCEPTED,
      'before:bg-marine': type === EBookingStatusType.CONFIRMED || type === EUserStatusType.VERIFIED,
      'before:bg-warm-green': type !== EBookingStatusType.CANCELLED && type !== EBookingStatusType.REQUESTED && type !== EBookingStatusType.CONFIRMED && type !== EUserStatusType.REJECTED && type !== EUserStatusType.ACCEPTED && type !== EUserStatusType.VERIFIED,
    }
  );
  return (
    <span className={spanClassName} {...rest}>
      {children}
    </span>
  );
};
